import getDefaultPath from '../../helpers/urlSync';
import { getLikeKey } from '../../helpers/changelog';
import actions, { getView } from './actions';
import agendaActions from '../agenda/actions';
import authActions from '../auth/actions';
import recordsActions from '../records/actions';
import prescriptionsActions from '../prescriptions/actions';
import certificateActions from '../certificate/actions';

const preKeys = getDefaultPath();

const moduleManagerInitState = {
  searchResults: [],
  searchLoading: false,
  selectedProfessional: null,
  customUsers: [],
  modules: {
    twilio: {},
    ai: {},
    aiRecorder: {},
    tv: {},
  },
  freePeriods: {
    twilio: {},
    ai: {},
    aiRecorder: {},
    tv: {},
  },
  loadingProfessional: false,
  loadingEmail: false,
  authStatusMap: {},
  loadingAuthStatus: false,
  togglingUid: null,
  loadingModules: false,
  savingModules: false,
  history: [],
  loadingHistory: false,
};

// Aplica um like (liked=true) ou desfaz (liked=false) nos mapas locais, sem
// esperar o banco; o erro do saga chama de novo com o valor invertido.
function applyLikeLocally(state, { entryKey, itemId, liked }) {
  const key = getLikeKey(entryKey, itemId);
  const currentCount = state.changelogLikeCounts[key] || 0;
  const nextCount = liked ? currentCount + 1 : Math.max(currentCount - 1, 0);
  const myChangelogLikes = { ...state.myChangelogLikes };
  if (liked) {
    myChangelogLikes[key] = true;
  } else {
    delete myChangelogLikes[key];
  }
  return {
    ...state,
    myChangelogLikes,
    changelogLikeCounts: { ...state.changelogLikeCounts, [key]: nextCount },
  };
}

const initState = {
  collapsed: window.innerWidth < 1220,
  forceOpenSidebar: window.innerWidth >= 1220,
  view: getView(window.innerWidth),
  height: window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  reloadApp: false,
  generalSettingsKey: '',
  pageWithAbsoluteFooterMounted: {
    '/dashboard/settings': false,
  },
  changeLog: null,
  changelogPage: {
    entries: {},
    hasMore: false,
    oldestKey: null,
    loading: false,
    loaded: false,
  },
  scrollTrigger: false,
  savedAllChangesProp: {},
  floatButtonValue: ['chat', 'waitList', 'whatsapp', 'block'],
  alertNotice: null,
  updatingAlert: false,
  savingSystemUpdate: false,
  generatingChangelogItems: false,
  generatedChangelogItems: null,
  syncingChangelogFromJira: false,
  updatingChangelogKey: null,
  changelogFeedbackSubmission: null,
  myChangelogFeedback: {},
  loadingMyChangelogFeedback: false,
  changelogFeedback: [],
  loadingChangelogFeedback: false,
  markingChangelogFeedbackId: null,
  changelogLikeCounts: {},
  myChangelogLikes: {},
  activeChangelogKey: null,
  savingActiveChangelog: false,
  // Module Manager State
  moduleManager: moduleManagerInitState,
};
export default function appReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return {
        ...initState,
        maintenance: state.maintenance,
      };
    case actions.CANCEL_LISTENERS_SUCCESS:
      return {
        ...state,
        removeListeners: true,
      };
    case actions.SET_CANCEL_LISTENERS:
      return {
        ...state,
        removeListeners: action.payload,
      };
    case agendaActions.PENDING_FETCH_SUCCESS:
      return {
        ...state,
        removeListeners: false,
      };
    case agendaActions.CONFIRMED_FETCH_SUCCESS:
      return {
        ...state,
        removeListeners: false,
      };
    case agendaActions.REJECTED_FETCH_SUCCESS:
      return {
        ...state,
        removeListeners: false,
      };
    case agendaActions.CANCELED_FETCH_SUCCESS:
      return {
        ...state,
        removeListeners: false,
      };
    case actions.COLLAPSE_CHANGE:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case actions.PERMANENT_COLLAPSE_CHANGE:
      return {
        ...state,
        forceOpenSidebar: action.payload,
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height,
        };
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return { ...state, openKeys: action.openKeys };
    case actions.CHANGE_CURRENT:
      return { ...state, current: action.current };
    case actions.CLOSE_ALL:
      return { ...state, current: [], openKeys: [] };
    case actions.SELECT_ADDRESS:
      return {
        ...state,
        selectedAddress: action.payload,
      };
    case actions.NEED_APP_RELOAD:
      return {
        ...state,
        reloadApp: true,
      };
    case actions.CHANGE_GENERAL_SETTINGS_KEY:
      return {
        ...state,
        generalSettingsKey: action.payload,
      };
    case actions.PAGE_WITH_ABSOLUTE_FOOTER_MOUNTED:
      return {
        ...state,
        pageWithAbsoluteFooterMounted: {
          ...state.pageWithAbsoluteFooterMounted,
          [action.payload]: true,
        },
      };
    case actions.PAGE_WITH_ABSOLUTE_FOOTER_UNMOUNTED:
      return {
        ...state,
        pageWithAbsoluteFooterMounted: {
          ...state.pageWithAbsoluteFooterMounted,
          [action.payload]: false,
        },
      };
    case actions.FETCH_SERVICE_CONTRACT_SUCCESS:
      return {
        ...state,
        serviceContractVersion: action.payload.version,
        serviceContractDocument: action.payload.document,
      };
    case actions.SAVING_SERVICE_CONTRACT:
      return {
        ...state,
        savingServiceContract: true,
      };
    case actions.ACCEPT_SERVICE_CONTRACT_SUCCESS:
      return {
        ...state,
        savingServiceContract: false,
      };
    case actions.ACCEPT_SERVICE_CONTRACT_ERROR:
      return {
        ...state,
        savingServiceContract: null,
      };
    case actions.FETCH_SYSTEM_UPDATES_CHANGELOG_SUCCESS:
      return {
        ...state,
        changeLog: action.payload,
      };
    case actions.FETCH_COMPLETE_SYSTEM_UPDATES_CHANGELOG_SUCCESS:
      return {
        ...state,
        completeChangeLog: action.payload,
      };
    case actions.FETCH_CHANGELOG_PAGE:
      return {
        ...state,
        changelogPage: { ...state.changelogPage, loading: true },
      };
    case actions.FETCH_CHANGELOG_PAGE_SUCCESS:
      return {
        ...state,
        changelogPage: {
          entries: action.payload.reset
            ? action.payload.entries
            : { ...state.changelogPage.entries, ...action.payload.entries },
          hasMore: action.payload.hasMore,
          oldestKey: action.payload.oldestKey,
          loading: false,
          loaded: true,
        },
      };
    case actions.FETCH_CHANGELOG_PAGE_ERROR:
      return {
        ...state,
        changelogPage: { ...state.changelogPage, loading: false, loaded: true },
      };
    case actions.SAVE_SYSTEM_UPDATE:
      return {
        ...state,
        savingSystemUpdate: true,
      };
    case actions.SAVE_SYSTEM_UPDATE_SUCCESS:
      return {
        ...state,
        savingSystemUpdate: false,
      };
    case actions.SAVE_SYSTEM_UPDATE_ERROR:
      return {
        ...state,
        savingSystemUpdate: null,
      };
    case actions.GENERATE_CHANGELOG_ITEMS:
      return {
        ...state,
        generatingChangelogItems: true,
        generatedChangelogItems: null,
      };
    case actions.GENERATE_CHANGELOG_ITEMS_SUCCESS:
      return {
        ...state,
        generatingChangelogItems: false,
        generatedChangelogItems: action.payload,
      };
    case actions.GENERATE_CHANGELOG_ITEMS_ERROR:
      return {
        ...state,
        generatingChangelogItems: null,
      };
    case actions.SYNC_CHANGELOG_FROM_JIRA:
      return {
        ...state,
        syncingChangelogFromJira: true,
      };
    case actions.SYNC_CHANGELOG_FROM_JIRA_SUCCESS:
      return {
        ...state,
        syncingChangelogFromJira: false,
      };
    case actions.SYNC_CHANGELOG_FROM_JIRA_ERROR:
      return {
        ...state,
        syncingChangelogFromJira: null,
      };
    case actions.SET_CHANGELOG_STATUS:
    case actions.DISCARD_CHANGELOG_ENTRY:
      return {
        ...state,
        updatingChangelogKey: action.payload.entryKey,
      };
    case actions.SET_CHANGELOG_STATUS_SUCCESS:
    case actions.SET_CHANGELOG_STATUS_ERROR:
    case actions.DISCARD_CHANGELOG_ENTRY_SUCCESS:
    case actions.DISCARD_CHANGELOG_ENTRY_ERROR:
      return {
        ...state,
        updatingChangelogKey: null,
      };
    case actions.SEND_CHANGELOG_FEEDBACK:
      return {
        ...state,
        changelogFeedbackSubmission: {
          entryKey: action.payload.entryKey,
          status: 'sending',
        },
      };
    case actions.SEND_CHANGELOG_FEEDBACK_SUCCESS:
      return {
        ...state,
        changelogFeedbackSubmission: {
          entryKey: action.payload.entryKey,
          status: 'sent',
        },
        myChangelogFeedback: action.payload.feedback
          ? { ...state.myChangelogFeedback, [action.payload.entryKey]: action.payload.feedback }
          : state.myChangelogFeedback,
      };
    case actions.FETCH_MY_CHANGELOG_FEEDBACK:
      return {
        ...state,
        loadingMyChangelogFeedback: true,
      };
    case actions.FETCH_MY_CHANGELOG_FEEDBACK_SUCCESS:
      return {
        ...state,
        myChangelogFeedback: action.payload,
        loadingMyChangelogFeedback: false,
      };
    case actions.FETCH_MY_CHANGELOG_FEEDBACK_ERROR:
      return {
        ...state,
        loadingMyChangelogFeedback: false,
      };
    case actions.SEND_CHANGELOG_FEEDBACK_ERROR:
      return {
        ...state,
        changelogFeedbackSubmission: {
          entryKey: action.payload.entryKey,
          status: 'error',
        },
      };
    case actions.FETCH_CHANGELOG_FEEDBACK:
      return {
        ...state,
        loadingChangelogFeedback: true,
      };
    case actions.FETCH_CHANGELOG_FEEDBACK_SUCCESS:
      return {
        ...state,
        changelogFeedback: action.payload,
        loadingChangelogFeedback: false,
      };
    case actions.FETCH_CHANGELOG_FEEDBACK_ERROR:
      return {
        ...state,
        loadingChangelogFeedback: false,
      };
    case actions.MARK_CHANGELOG_FEEDBACK_READ:
      return {
        ...state,
        markingChangelogFeedbackId: action.payload.id,
      };
    case actions.MARK_CHANGELOG_FEEDBACK_READ_SUCCESS:
      return {
        ...state,
        markingChangelogFeedbackId: null,
        changelogFeedback: state.changelogFeedback.map((feedback) => (
          feedback.id === action.payload.id
            ? { ...feedback, read: action.payload.read }
            : feedback
        )),
      };
    case actions.MARK_CHANGELOG_FEEDBACK_READ_ERROR:
      return {
        ...state,
        markingChangelogFeedbackId: null,
      };
    case actions.FETCH_ACTIVE_CHANGELOG_SUCCESS:
      return {
        ...state,
        activeChangelogKey: action.payload,
      };
    case actions.SET_ACTIVE_CHANGELOG:
      return {
        ...state,
        savingActiveChangelog: true,
      };
    case actions.SET_ACTIVE_CHANGELOG_SUCCESS:
      return {
        ...state,
        activeChangelogKey: action.payload,
        savingActiveChangelog: false,
      };
    case actions.SET_ACTIVE_CHANGELOG_ERROR:
      return {
        ...state,
        savingActiveChangelog: false,
      };
    case actions.FETCH_CHANGELOG_LIKES_SUCCESS:
      return {
        ...state,
        changelogLikeCounts: { ...state.changelogLikeCounts, ...action.payload.counts },
        myChangelogLikes: action.payload.mine,
      };
    case actions.TOGGLE_CHANGELOG_LIKE:
      return applyLikeLocally(state, action.payload);
    case actions.TOGGLE_CHANGELOG_LIKE_ERROR:
      return applyLikeLocally(state, { ...action.payload, liked: !action.payload.liked });
    case actions.SCROOL_WRAPPER_TO_BOTTOM:
      return {
        ...state,
        scrollTrigger: !state.scrollTrigger,
      };
    case actions.CHANGE_SAVED_ALL_CHANGES:
      return {
        ...state,
        savedAllChangesProp: {
          ...state.savedAllChangesProp,
          [action.payload.id]: { ...action.payload.obj },
        },
      };
    case actions.DISCARD_SAVED_ALL_CHANGES:
      return {
        ...state,
        savedAllChangesProp: {},
      };
    case actions.CHANGE_SPECIFIC_SAVED_ALL_CHANGES_FIELD:
      return {
        ...state,
        savedAllChangesProp: {
          ...state.savedAllChangesProp,
          [action.payload.id]: {
            ...state.savedAllChangesProp[action.payload.id],
            [action.payload.field]: action.payload.fieldValue,
          },
        },
      };
    case recordsActions.DISCARD_NEW_RECORD_CHANGES:
      return {
        ...state,
        savedAllChangesProp: {
          ...state.savedAllChangesProp,
          [action.payload.id]: {
            ...state.savedAllChangesProp[action.payload.id],
            record: true,
          },
        },
      };
    case prescriptionsActions.DISCARD_PRESCRIPTION:
      return {
        ...state,
        savedAllChangesProp: {
          ...state.savedAllChangesProp,
          [action.payload.id]: {
            ...state.savedAllChangesProp[action.payload.id],
            prescription: true,
          },
        },
      };
    case certificateActions.DISCARD_NEW_CERTIFICATE_CHANGES:
      return {
        ...state,
        savedAllChangesProp: {
          ...state.savedAllChangesProp,
          [action.payload.id]: {
            ...state.savedAllChangesProp[action.payload.id],
            certificate: true,
            medicalReport: true,
            otherDocument: true,
          },
        },
      };
    case actions.SET_MAINTENANCE:
      return {
        ...state,
        maintenance: action.payload,
      };
    case actions.SET_SHOW_POPOVER_COMPONENT_TO_PRINT:
      return {
        ...state,
        alreadyShownPopoverComponentToPrint: action.payload.alreadyShownPopoverComponentToPrint,
      };
    case actions.SET_PREVENT_CLOSE_MODAL_VISIBLE:
      return {
        ...state,
        preventCloseModalVisible: action.payload.value,
      };
    case actions.FETCH_SYSTEM_ALERT_SUCCESS:
      return {
        ...state,
        alertNotice: action.payload,
      };
    case actions.UPDATE_SYSTEM_ALERT:
      return {
        ...state,
        updatingAlert: true,
      };
    case actions.UPDATE_SYSTEM_ALERT_ERROR:
      return {
        ...state,
        updatingAlert: false,
      };
    case actions.UPDATE_SYSTEM_ALERT_SUCCESS:
      return {
        ...state,
        updatingAlert: false,
      };
    case actions.CHANGE_FLOAT_BUTTON_VALUE:
      return {
        ...state,
        floatButtonValue: action.payload,
      };
    // Module Manager Cases
    case actions.SEARCH_PROFESSIONALS_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          searchLoading: true,
        },
      };
    case actions.SEARCH_PROFESSIONALS_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          searchResults: action.payload.professionals,
          searchLoading: false,
        },
      };
    case actions.SEARCH_PROFESSIONALS_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          searchResults: [],
          searchLoading: false,
        },
      };
    case actions.SEARCH_PROFESSIONALS_ADMIN_CLEAR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          searchResults: [],
        },
      };
    case actions.FETCH_PROFESSIONAL_DATA_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingProfessional: true,
        },
      };
    case actions.FETCH_PROFESSIONAL_DATA_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          selectedProfessional: action.payload.professional,
          customUsers: action.payload.customUsers,
          loadingProfessional: false,
        },
      };
    case actions.FETCH_PROFESSIONAL_DATA_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingProfessional: false,
        },
      };
    case actions.FETCH_PROFESSIONAL_EMAIL_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingEmail: true,
        },
      };
    case actions.FETCH_PROFESSIONAL_EMAIL_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          selectedProfessional: state.moduleManager.selectedProfessional
            ? {
              ...state.moduleManager.selectedProfessional,
              email: action.payload.email,
            }
            : state.moduleManager.selectedProfessional,
          loadingEmail: false,
        },
      };
    case actions.FETCH_PROFESSIONAL_EMAIL_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingEmail: false,
        },
      };
    case actions.FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          authStatusMap: {},
          loadingAuthStatus: true,
        },
      };
    case actions.FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          authStatusMap: action.payload.authStatusMap,
          loadingAuthStatus: false,
        },
      };
    case actions.FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingAuthStatus: false,
        },
      };
    case actions.SET_USER_ENABLED_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          togglingUid: action.payload.uid,
        },
      };
    case actions.SET_USER_ENABLED_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          togglingUid: null,
          authStatusMap: {
            ...state.moduleManager.authStatusMap,
            [action.payload.uid]: {
              enabled: action.payload.enabled,
              lastSignInTime: action.payload.lastSignInTime,
              lastRefreshTime: action.payload.lastRefreshTime,
              notFound: false,
            },
          },
        },
      };
    case actions.SET_USER_ENABLED_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          togglingUid: null,
        },
      };
    case actions.FETCH_PROFESSIONAL_MODULES_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingModules: true,
        },
      };
    case actions.FETCH_PROFESSIONAL_MODULES_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          modules: action.payload.modules,
          freePeriods: action.payload.freePeriods || state.moduleManager.freePeriods,
          loadingModules: false,
        },
      };
    case actions.FETCH_PROFESSIONAL_MODULES_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingModules: false,
        },
      };
    case actions.UPDATE_PROFESSIONAL_MODULES_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          savingModules: true,
        },
      };
    case actions.UPDATE_PROFESSIONAL_MODULES_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          savingModules: false,
        },
      };
    case actions.UPDATE_PROFESSIONAL_MODULES_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          savingModules: false,
        },
      };
    case actions.FETCH_MODULE_HISTORY_ADMIN:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingHistory: true,
        },
      };
    case actions.FETCH_MODULE_HISTORY_ADMIN_SUCCESS:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          history: action.payload.history,
          loadingHistory: false,
        },
      };
    case actions.FETCH_MODULE_HISTORY_ADMIN_ERROR:
      return {
        ...state,
        moduleManager: {
          ...state.moduleManager,
          loadingHistory: false,
        },
      };
    case actions.CLEAR_MODULE_MANAGER_STATE:
      return {
        ...state,
        moduleManager: moduleManagerInitState,
      };
    default:
      return state;
  }
  return state;
}
